import { INIT_DONE, INIT_ERROR } from '../actionConstants';
import defaultState from './initDefaultState';
import { Init } from './initTypes';

export default function (state: Init = defaultState, action: any): Init {
  switch (action.type) {
    case INIT_DONE:
      return {
        loading: false,
        error: false,
      };
    case INIT_ERROR:
      return {
        loading: false,
        error: action.payload || true,
      };
    default:
      return state;
  }
}
